import React from "react";
import styled from "styled-components";
import { IconCheck10 } from "../../icons-ts";
import { colors } from "../../lib/constant";
import { DottedLink } from "./DottedLink";
import { Modal } from "./Modal";
import { Paragraph } from "./Paragraph";
import { Title } from "./Title";

const FeaturesItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

const Features = styled.div`
  margin: 10px 0;
`;

const Check = styled(IconCheck10)`
  margin-right: 10px;
`;

const ATag = styled.a`
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

const ContactLink = styled(DottedLink)`
  margin: 0 5px;
  &:hover ${ATag} {
    color: #fff;
  }
`;

export const ModalRequests = ({
  isOpen,
  onRequestClose,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
}) => (
  <Modal noSubTitle onRequestClose={onRequestClose} isOpen={isOpen}>
    <Title htmlLevel={2} theme="titleBodyStyle">
      Volume based pricing
    </Title>
    {/* <ModalPrice price={79} /> */}
    <Paragraph>
      Pricing is based on the volume of requests you do each month. A request is
      counted for each successful
      <br />
      transaction such as :
    </Paragraph>
    <Features>
      <FeaturesItem>
        <Check width="10" fill={colors.greyDrk} /> activation of a loyalty card
      </FeaturesItem>
      <FeaturesItem>
        <Check width="10" fill={colors.greyDrk} /> purchase tracking
      </FeaturesItem>
      <FeaturesItem>
        <Check width="10" fill={colors.greyDrk} /> voucher redemption
      </FeaturesItem>
      <FeaturesItem>
        <Check width="10" fill={colors.greyDrk} /> ...
      </FeaturesItem>
    </Features>
    <Paragraph>
      Unsuccessful requests are never counted. The first 10.000 requests are
      included in the basic pricing. More
      <br />
      requests are available with additionnal 10.000 requests package. A new
      package is automatically activated on a<br />
      monthly basis when required for a forfait pricing of 100 € VAT excluded.
      <br />
      Please
      <ContactLink>
        <ATag href="mailto:info@igloo.be">contact us</ATag>
      </ContactLink>
      for further detail on volume pricing.
    </Paragraph>
  </Modal>
);
